import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.84 10.617 21.449 5.83a1.5 1.5 0 0 0-2.012-.67l-2.332 1.165-4.912-1.3a.76.76 0 0 0-.384 0l-4.912 1.3-2.331-1.166a1.5 1.5 0 0 0-2.013.67L.16 10.617a1.5 1.5 0 0 0 .67 2.013l2.531 1.266 5.202 3.715a.8.8 0 0 0 .254.117l6 1.5a.75.75 0 0 0 .713-.196l5.163-5.164 2.477-1.239a1.5 1.5 0 0 0 .67-2.011m-5.145 3.128-3.226-2.584a.75.75 0 0 0-1.001.058c-1.67 1.681-3.53 1.469-4.718.719L13.804 8h2.982l2.551 5.101zM3.894 6.5l1.919.958-2.397 4.786-1.916-.957zm10.875 11.169L9.32 16.307l-4.613-3.294 2.625-5.25L12 6.526l.919.243L8.7 10.864l-.007.008a1.5 1.5 0 0 0 .255 2.326c1.927 1.231 4.253 1.032 6.085-.468l2.592 2.082zm5.812-5.426L18.19 7.462l1.918-.962 2.393 4.787zm-8.226 8.688a.75.75 0 0 1-.91.546L7.54 20.5a.7.7 0 0 1-.254-.117l-2.47-1.765a.75.75 0 0 1 .871-1.219l2.354 1.682 3.773.942a.75.75 0 0 1 .545.909z"
    }, null, -1)
  ])))
}
export default { render: render }